import { userConstants } from '../_constants'
import { userService } from '../_services'
import { alertActions } from '../_actions'
import { history } from '../_helpers'
import config from 'config'
import Crypto from 'crypto-js'

const userActions = {
  login,
  SSOlogin,
  refresh,
  logout,
  register,
  insert,
  getAll,
  getById,
  update,
  delete: _delete
}
export default userActions

function login(username, password) {
  return async dispatch => {
    dispatch(request({ username }))

    await userService.login(username, password).then(
      user => {
        if (user.status === 'fail') {
          dispatch(failure(user))
          history.push('/')
        } else {
          dispatch(success(user))
          history.push('/Dashboard')
        }
      },
      error => {
        dispatch(failure(error.toString()))
        dispatch(alertActions.error(error.toString()))
      }
    )
  }

  function request(user) {
    return { type: userConstants.LOGIN_REQUEST, user }
  }
  function success(user) {
    return { type: userConstants.LOGIN_SUCCESS, user }
  }
  function failure(error) {
    return { type: userConstants.LOGIN_FAILURE, error }
  }
}

function SSOlogin(UserData) {
  return async dispatch => {
    dispatch(request(UserData))
    await userService.SSOlogin(UserData).then(
      user => {
        if (user.status === 'fail') {
          dispatch(failure(user))
          history.push('/')
        } else {
          dispatch(success(user))
          history.push('/')
        }
      },
      error => {
        dispatch(failure(error.toString()))
        dispatch(alertActions.error(error.toString()))
      }
    )
  }

  function request(user) {
    return { type: userConstants.LOGIN_SSO_REQUEST, user }
  }
  function success(user) {
    return { type: userConstants.LOGIN_SSO_SUCCESS, user }
  }
  function failure(error) {
    return { type: userConstants.LOGIN_SSO_FAILURE, error }
  }
}

function refresh() {
  const username = JSON.parse(localStorage.getItem('user')).id

  return async dispatch => {
    dispatch(request({ username }))

    await userService.refresh(username).then(
      user => {
        dispatch(success(user))
      },
      error => {
        dispatch(failure(error.toString()))
        dispatch(alertActions.error(error.toString()))
      }
    )
  }

  function request(user) {
    return { type: userConstants.REFRESH_REQUEST, user }
  }
  function success(user) {
    return { type: userConstants.REFRESH_SUCCESS, user }
  }
  function failure(error) {
    return { type: userConstants.REFRESH_FAILURE, error }
  }
}

function logout() {
  userService.logout()
  return { type: userConstants.LOGOUT }
}

function register(user) {
  return async dispatch => {
    dispatch(request(user))

    await userService.register(user).then(
      user => {
        dispatch(success(user))
        history.push('/login')
        dispatch(alertActions.success('Registration successful'))
      },
      error => {
        dispatch(failure(error.toString()))
        dispatch(alertActions.error(error.toString()))
      }
    )
  }

  function request(user) {
    return { type: userConstants.REGISTER_REQUEST, user }
  }
  function success(user) {
    return { type: userConstants.REGISTER_SUCCESS, user }
  }
  function failure(error) {
    return { type: userConstants.REGISTER_FAILURE, error }
  }
}

function insert(user) {
  return async dispatch => {
    await dispatch(request())

    await userService
      .insert(user)
      .then(
        message => dispatch(success(message)),
        error => dispatch(failure(error.toString()))
      )
  }

  function request() {
    return { type: userConstants.INSERT_REQUEST }
  }
  function success(user) {
    return { type: userConstants.INSERT_SUCCESS, user }
  }
  function failure(error) {
    return { type: userConstants.INSERT_FAILURE, error }
  }
}

function getAll() {
  return async dispatch => {
    dispatch(request())

    await userService
      .getAll()
      .then(
        users => dispatch(success(users)),
        error => dispatch(failure(error.toString()))
      )
  }

  function request() {
    return { type: userConstants.GETALL_REQUEST }
  }
  function success(users) {
    var _ciphertext = Crypto.AES.decrypt(
      users.encryptresult.toString(),
      `${config.AESKEY}`
    )
    var decryptedData = JSON.parse(_ciphertext.toString(Crypto.enc.Utf8))
    return { type: userConstants.GETALL_SUCCESS, decryptedData }
  }
  function failure(error) {
    return { type: userConstants.GETALL_FAILURE, error }
  }
}

function getById(id) {
  return async dispatch => {
    dispatch(request())

    await userService
      .getById(id)
      .then(
        users => dispatch(success(users)),
        error => dispatch(failure(error.toString()))
      )
  }
  function request() {
    return { type: userConstants.GETBYID_REQUEST }
  }
  function success(users) {
    var _ciphertext = Crypto.AES.decrypt(
      users.encryptresult.toString(),
      `${config.AESKEY}`
    )
    var decryptedData = JSON.parse(_ciphertext.toString(Crypto.enc.Utf8))
    return { type: userConstants.GETBYID_SUCCESS, decryptedData }
  }
  function failure(error) {
    return { type: userConstants.GETBYID_FAILURE, error }
  }
}

function update(user) {
  return async dispatch => {
    dispatch(request())

    await userService
      .update(user)
      .then(
        message => dispatch(success(message)),
        error => dispatch(failure(error.toString()))
      )
  }
  function request() {
    return { type: userConstants.UPDATE_REQUEST }
  }
  function success(message) {
    return { type: userConstants.UPDATE_SUCCESS, message }
  }
  function failure(error) {
    return { type: userConstants.UPDATE_FAILURE, error }
  }
}

function _delete(user) {
  return async dispatch => {
    dispatch(request())

    await userService
      .delete(user)
      .then(
        user => dispatch(success(user)),
        error => dispatch(failure(error.toString()))
      )
  }

  function request(user) {
    return { type: userConstants.DELETE_REQUEST, user }
  }
  function success(user) {
    return { type: userConstants.DELETE_SUCCESS, user }
  }
  function failure(user, error) {
    return { type: userConstants.DELETE_FAILURE, user, error }
  }
}



// WEBPACK FOOTER //
// ./src/_actions/user.actions.js